export class AddCommentConstants {
    static noBusinessUnitsConfigured = "Business Units not configured correcly";
    static TITLE_LBL = "Add Comment";
    static BUSINESS_UNIT_LABEL = "Business Unit";
    static COMMENT_TEXT_LABEL = "Comment";
    static COMMENT_FORM_GROUP = "commentFormGroup";
    static COMMENT_TYPE = "Internal";
    static COMMENT_TEXT_CONTROL = "commentText";
    static ATT_MANAGER_CONTROL = "attachmentManager";
    static ERROR_SAVING_COMMENT = "Failed to add Comment, please contact your administrator";
}
